/*
	Abre el aula de BigBlueButton en una pestaña nueva (es una página externa, no un archivo: el visor de
	WAPP no aplica). La pestaña se abre en el mismo clic, ANTES de pedir la URL, porque los navegadores
	bloquean las ventanas que se abren tras una espera; luego se le pone la dirección. La URL se usa una
	vez y no se guarda.
*/
export const mensajeDeAula = (e: any): string =>
	e?.response?.data?.message || "No pudimos abrir el aula. Intenta otra vez en un momento."

export const abrirAulaEnPestana = async (pedirUrl: () => Promise<string>): Promise<void> =>
{
	const pestana = window.open("", "_blank")
	if (!pestana) throw { response: { data: { message: "Tu navegador bloqueó la pestaña. Permite las ventanas emergentes e intenta otra vez." } } }
	try
	{
		const url = await pedirUrl()
		pestana.opener = null
		pestana.location.href = url
	}
	catch (e)
	{
		pestana.close()
		throw e
	}
}
